exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll::-webkit-scrollbar{width:8px}.scroll::-webkit-scrollbar-thumb{background-color:#00abeb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/js/components/DestinationMenu/style.css
// module id = QdGa
// module chunks = 0